// client/src/components/creditAssignment/CreditAssignmentRequests.js
//
// Elenco richieste di cessione del credito.
// - azienda: solo le proprie
// - admin: tutte (link al dettaglio per inserire le condizioni)

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Files } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { formatCurrencyWithSymbol } from '../utils/formatUtils';
import { fetchRequests } from './creditAssignmentApi';

const CreditAssignmentRequests = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';

  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchRequests()
      .then(setRequests)
      .catch(() => setError(t('creditAssignment.errors.fetchRequests')))
      .finally(() => setLoading(false));
  }, [t]);

  const statusLabel = (s) => t(`creditAssignment.status.${s}`, { defaultValue: s });

  const detailPath = (id) =>
    isAdmin ? `/admin/credit-assignment/requests/${id}` : `/company/credit-assignment/requests/${id}`;

  if (loading) return <div className="loading">{t('common.loading')}</div>;

  return (
    <div className="company-dashboard">
      <div className="card">
        <div className="card-title">
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Files className="card-title-icon" size={20} />
            <span>{t('creditAssignment.requests.title')}</span>
          </div>
        </div>

        {error && <div className="alert alert-danger">{error}</div>}

        <table>
          <thead>
            <tr>
              <th>{t('creditAssignment.requests.id')}</th>
              <th>{t('creditAssignment.requests.date')}</th>
              {isAdmin && <th>{t('creditAssignment.requests.company')}</th>}
              <th>{t('creditAssignment.requests.client')}</th>
              <th>{t('creditAssignment.requests.amount')}</th>
              <th>{t('creditAssignment.requests.status')}</th>
              <th>{t('common.action')}</th>
            </tr>
          </thead>
          <tbody>
            {requests.length > 0 ? (
              requests.map((r) => (
                <tr key={r.id}>
                  <td>#{r.requestId}</td>
                  <td>{new Date(r.createdAt).toLocaleDateString()}</td>
                  {isAdmin && <td>{r.company?.name || '-'}</td>}
                  <td>{r.client?.clientName || '-'}</td>
                  <td>{formatCurrencyWithSymbol(r.invoiceAmount, r.currency || 'EUR')}</td>
                  <td>
                    <span className={`status status-${r.status}`}>{statusLabel(r.status)}</span>
                  </td>
                  <td>
                    <Link to={detailPath(r.id)} className="view-btn">
                      {t('common.view')}
                    </Link>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={isAdmin ? 7 : 6}>{t('creditAssignment.requests.none')}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CreditAssignmentRequests;
